export default __webpack_public_path__ + "static/media/sdk.6ce38617.svg";